let host = window.location.host;
let protocol = 'wss';

if (process.env.NODE_ENV === 'development') {
  host = require('../setupProxy').host;
}

if (window.location.protocol === 'http:') {
  protocol = 'ws';
} else {
  protocol = 'wss';
}

export default {
  socket: () => `${protocol}://${host}/app-portal/socketServer/v1`
};
